module.exports = __webpack_public_path__ + "img/pix.cf548128.png";